import React from 'react'
import SettingsContent from './SettingsContent';
// import { Link } from 'react-router-dom';
import Attendees from './Attendees';
import RestrictionsContent from './RestrictionsContent';
import TransactionsData from './TransactionsData';
import { Link } from 'react-router-dom';
const EventsTabs = ({id}) => {
    return (
        <div className="EventsTabs">
              <div className="container-fluid">
                <div className='back-arrow'>
                    <Link to="/events">
                        <i class="fa fa-arrow-left" aria-hidden="true"></i><span>Back</span>
                    </Link>
                </div>
                   <h1 className="events-heading mb-3">Events details</h1>
                        <div className="tabs-wrap">
                        <ul className="nav nav-tabs events-tabs" id="myTab" role="tablist">
                            <li className="nav-item">
                                <a  className="nav-link active" id="setting-tab" data-toggle="tab" href="#settings" role="tab" aria-controls="settings" aria-selected="true">Settings</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" id="Attendees-tab" data-toggle="tab" href="#Attendees" role="tab" aria-controls="Attendees" aria-selected="false">Attendees</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" id="Restrictions-tab" data-toggle="tab" href="#Restrictions" role="tab" aria-controls="Restrictions" aria-selected="false">Restrictions</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" id="Transactions-tab" data-toggle="tab" href="#Transactions" role="tab" aria-controls="contact" aria-selected="false">Transactions</a>
                            </li>
                        </ul>
                        <div className="tab-content" id="myTabContent">
                            <div className="tab-pane fade show active" id="settings" role="tabpanel" aria-labelledby="setting-tab"><SettingsContent id={id} /></div>
                            <div className="tab-pane fade" id="Attendees" role="tabpanel" aria-labelledby="Attendees-tab"><Attendees id={id} /></div>
                            <div className="tab-pane fade" id="Restrictions" role="tabpanel" aria-labelledby="Restrictions-tab"><RestrictionsContent id={id} /></div>
                            <div className="tab-pane fade" id="Transactions" role="tabpanel" aria-labelledby="Transactions-tab"><TransactionsData id={id} /></div>
                        </div>
                     
                     </div>
                
              </div>
        </div>
    )
}

export default EventsTabs
